<template>
  <!--企业接入管理入口-->
  <div class="ent-access">
    <!--api签署管理-->
    <template v-if="typeStatus === 'apiSet'">
      <api-set />
    </template>
    <template v-if="typeStatus === 'entAuth'">
      <!-- 企业认证管理 -->
      <ent-auth />
    </template>
    <template v-if="typeStatus === 'signCallback'">
      <sign-callback />
    </template>
    <template v-if="typeStatus === 'entSign'">
      <ent-sign />
    </template>
    <template v-if="typeStatus === 'setUrl'">
      <set-url />
    </template>
    <template v-if="typeStatus === 'digital_certificate'">
      <digital></digital>
    </template>
    <template v-if="typeStatus === 'sign_check'">
      <signCheck />
    </template>
    <template v-if="typeStatus === 'appkeyManage'">
      <!-- APPKEY管理 -->
      <appkey-manage />
    </template>
  </div>
</template>

<script>
  import ApiSet from "../../components/ent-access/apiSet";
  import EntAuth from "../../components/ent-access/entAuth";
  import SignCallback from "../../components/ent-access/signCallback";
  import EntSign from "../../components/ent-access/entSign";
  import SetUrl from "../../components/ent-access/setUrl";
  import digital from '../signSettings/digital';
  import signCheck from '../tpl/signCheck';
  import AppkeyManage from "../../components/ent-access/appkeyManage";
  export default {
    components: {SetUrl, EntSign, SignCallback, EntAuth, ApiSet, digital, signCheck, AppkeyManage},
    data() {
      return {
        typeStatus: 'apiSet',
        badge: 0
      }
    },
    created() {
      this.typeStatus = this.$route.query.typeStatus
    },
    watch: {
      '$route': {
        handler({query}) {
          this.typeStatus = query ? query.typeStatus : 'apiSet'
        },
        deep: true
      }
    },
    name: "ent-access"
  }
</script>


<style lang="less" scoped>
  .ent-access {
    max-width: 1200px;
    margin: 0 auto;
  }

  .popper-content {
    p {
      text-align: left;
      padding: 10px 0 10px 20px;
    }
    p:hover {
      background: #ccc;
    }
  }

  nav.nav-bar {
    width: 100%;
    margin-top: 20px;
    border: 1px dashed #D7D7D7;
    overflow: hidden;
    li.nav-item {
      margin-right: 14px;
      padding: 10px 15px;
      color: #666;
      border: none;
      background: #fff;

      .link {
        display: inline-block;
        width: 100%;
        height: 100%;
      }
    }
    .nav-item.active .item {
      color: #ec1c1c;
    }
    ul.nav {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// pages/signInfo/entAccess.vue